// extracted by mini-css-extract-plugin
export default {"group":"app-react-components-form-components-ButtonSelector-ButtonSelector-module__group"};